import request from '@/utils/request'
import Api from '@/api/base/api-config'
// 获取工作台跟进任务数量
export const getTaskNum = (params) => {
  return request({
    method: 'get',
    url: Api.workbench.taskCount,
    params
  })
}
// 获取战绩排名数据
export const getRank = params => {
  return request({
    method: 'get',
    url: Api.workbench.rankList,
    params
  })
}
// 获取工作台未分配的数量
export const unDistribution = () => {
  return request({
    method: 'get',
    url: Api.workbench.unDistribution
  })
}
export const getSalesFunnelStatistics = (params) => {
  return request({
    url: Api.workbench.getSalesFunnelStatistics,
    method: "get",
    params
  })
}